"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var MaskedInput_1 = __importDefault(require("../../MaskedInput"));
var GenericMaskedInputField = function (_a) {
    var fields = _a.fields, item = _a.item, values = _a.values, setFieldValue = _a.setFieldValue, changeField = _a.changeField, errors = _a.errors;
    var _b = react_1.useState(fields && fields[item.stateKey]
        ? fields[item.stateKey]
        : values && values[item.stateKey]
            ? values[item.stateKey]
            : ""), value = _b[0], setValue = _b[1];
    var field = lodash_1.get(fields, item.stateKey, null);
    react_1.default.useEffect(function () {
        field ? setValue(field) : setValue("");
    }, [fields, field]);
    var endAdorn = function () {
        if (item.tooltip) {
            return {
                endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end" }, item.tooltip)),
            };
        }
        return undefined;
    };
    var _c = react_1.useState(item.masks ? item.masks[0].mask : item.mask || ""), mask = _c[0], setMask = _c[1];
    var currentMask = function (v) {
        var _a;
        if (item.masks) {
            setMask(((_a = item.masks.find(function (m) { return v <= m.letterCount; })) === null || _a === void 0 ? void 0 : _a.mask) || "");
        }
        else {
            setMask(item.mask || "");
        }
    };
    return (react_1.default.createElement(MaskedInput_1.default, { id: item.idHtml || item.stateKey, key: item.stateKey, mask: item.validatePhoneOrEmailMask
            ? value.length > 3 &&
                value
                    .replace(/[^A-Z0-9]/gi, "")
                    .slice(0, 3)
                    .match(/^[0-9]+$/)
                ? "+99 (99) 99999-9999"
                : ""
            : mask, maskChar: "", value: value, onChange: function (e) {
            setValue(e.target.value);
            currentMask(e.target.value.length);
            if (item.validateOnChange) {
                setFieldValue && setFieldValue(item.stateKey, e.target.value);
                setValue(e.target.value);
            }
        }, onBlur: function (e) {
            if (setFieldValue)
                setFieldValue(item.stateKey, e.target.value);
            if (changeField)
                changeField({
                    key: item.stateKey,
                    value: Object(item).hasOwnProperty("id")
                        ? { id: item.id, value: e.target.value }
                        : e.target.value,
                });
        }, variant: (item === null || item === void 0 ? void 0 : item.variant) || "outlined", label: item.label, error: !!lodash_1.get(errors, item.stateKey, null) ||
            !!lodash_1.get(errors, item.error, null), helperText: lodash_1.get(errors, item.stateKey, null) ||
            lodash_1.get(errors, item.error, null), disabled: item.disabled, InputProps: endAdorn() }));
};
exports.default = GenericMaskedInputField;
//# sourceMappingURL=GenericMaskedInputField.js.map